import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App'
import routerConfig from '../comm/router/config'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'
import api from '../comm/http/index'
import i18n from '../i18n/i18n'

Vue.config.productionTip = false
Vue.use(api)
Vue.use(Antd)
routerConfig(router)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  store,
  router,
  i18n,
  template: '<App/>',
  components: { App },
})



// WEBPACK FOOTER //
// ./src/daoba-match/main.js